import * as React from "react"
import type { SVGProps } from "react"
const SvgPieChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 11.57h6.95a8 8 0 0 0-2.29-4.66A8 8 0 0 0 13 4.62zm-2 8.95V4.62a7.7 7.7 0 0 0-5.01 2.64A7.8 7.8 0 0 0 4 12.57q0 3.04 1.99 5.31T11 20.52m2 0q2.75-.35 4.68-2.27a7.8 7.8 0 0 0 2.27-4.68H13zm-1 2.05a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.13 10 10 0 0 1-2.14-3.18 10 10 0 0 1-.79-3.9q0-2.07.79-3.9A10 10 0 0 1 4.92 5.5Q6.28 4.14 8.1 3.36a10 10 0 0 1 3.9-.79q2.07 0 3.89.79a10 10 0 0 1 3.17 2.15 10 10 0 0 1 2.15 3.17 10 10 0 0 1 .79 3.89 10 10 0 0 1-.79 3.88 10 10 0 0 1-2.14 3.18 10 10 0 0 1-3.17 2.15 10 10 0 0 1-3.9.79" />
  </svg>
)
export default SvgPieChart
